import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { BrowserRouter } from "react-router-dom";
import FloatingLogo from "./components/common/FloatingLogo";
import { ContactDialogProvider } from "./components/common";
import Router from "./Router";
import ResponsiveAppBar from "./components/views/ResponsiveAppBar";
import ResponsiveFooter from "./components/views/ResponsiveFooter";
import { lamactTheme } from "./theme/muiTheme";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={lamactTheme}>
        <CssBaseline />
        <ContactDialogProvider>
          <div>
            <ResponsiveAppBar />
            <FloatingLogo />
            <Box
              sx={{
                width: "100%",
                maxWidth: "100vw",
                overflow: "hidden",
              }}
            >
              <Router />
            </Box>
            <ResponsiveFooter />
          </div>
        </ContactDialogProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
